import confetti from "canvas-confetti";

export const shootQuizConfetti = () => {
  const duration = 1500;
  const end = Date.now() + duration;
  const colors = ["#22c55e", "#fbbf24", "#f59e0b", "#ef4444", "#3b82f6", "#ffffff"];

  const frame = () => {
    confetti({
      particleCount: 6,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.6 },
      colors,
      disableForReducedMotion: true,
      zIndex: 1000,
    });
    confetti({
      particleCount: 6,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.6 },
      colors,
      disableForReducedMotion: true,
      zIndex: 1000,
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };

  frame();
};
